import React, {
    useState,
    forwardRef,
    useImperativeHandle,
    useEffect,
    useRef,
  } from "react";
  import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
  import { IconPlus } from "@tabler/icons-react";
  import { IconTrash } from "@tabler/icons-react";

  const Brand = forwardRef(function (props, ref) {
    
  const imageRef = useRef();
  
   
  
    const [errors, setErrors] = useState({});
    const [popularImages, setPopularImages] = useState([]);
  
    const handleAddpopImg = () => {
      let image = {
        name: "News " + (popularImages.length + 1),
        image: null,
        imageFile: null,
        imageKey: "",
        show: popularImages.length === 0,
        ref: null,
      };
  
      setPopularImages([...popularImages, image]);
    };
  
    const validate = () => {
      const errors = {};
      return Object.keys(errors).length === 0;
    };
    useEffect(() => {
        let imageFile 
        console.log("Updated image files:");
        popularImages.forEach((img, index) => {
            const imageFile = img.imageFile;
          console.log(`Image `,imageFile)
        });
      }, [popularImages]);
      
      const getData = () => {
        const aboutData = popularImages.map((img) => ({
          image: img.image,
          imageFile: img.imageFile,
        }));
        console.log("getData ->", aboutData);
        return aboutData;
      };
      
  
    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate,
    }));
  
    const handleCroppedImage = (file) => {
      const updatedData = [{ ...data, herofile: file }];
      console.log("updatedData", updatedData);
      if (props.onDataReceive) {
        props.onDataReceive(updatedData);
      }
    };
  
    return (
      <>
        <div className="content d-block visible">
          <div className="content-header mb-3 d-flex justify-content-between">
            <div className="sec-titler">
              <h2 className="text-primary">Brand Logo Page</h2>
              <div className="title-shape"></div>
            </div>
            <div className="mb-0 text-right">
              <button
                className="btn btn-primary align-middle"
                onClick={handleAddpopImg}
              >
                <IconPlus className="me-sm-1 me-0" size={20} />
                Add Logo
              </button>
            </div>
          </div>
  
          {popularImages.map((img, index) => (
  <div className="col-sm-6 mb-3 position-relative" key={index}>
    <label className="form-label">Logo {index + 1}</label>
    <input
      type="file"
      accept="image/*"
      className="form-control"
      onChange={(e) => {
        const file = e.target.files[0];
        if (file) {
          const updatedImages = [...popularImages];
          updatedImages[index].image = URL.createObjectURL(file);
          updatedImages[index].imageFile = file;
          setPopularImages(updatedImages);
        }
      }}
    />
    {img.image && (
      <img
        src={img.image}
        alt={`Preview ${index + 1}`}
        style={{ marginTop: "10px", maxHeight: "150px" }}
      />
    )}
    <button
      type="button"
      onClick={() => {
        const updatedImages = popularImages.filter((_, i) => i !== index);
        setPopularImages(updatedImages);
      }}
      style={{
        position: "absolute",
        top: "0",
        right: "0",
        background: "transparent",
        border: "none",
        color: "red",
      }}
    >
      <IconTrash size={20} />
    </button>
  </div>
))}

  
          <StepperNavigationButtons
            index={props.index}
            steps={props.steps}
            navigate={props.navigate}
          />
        </div>
      </>
    );
  });
  
  export default Brand;
  